import React, { useState } from 'react';

import { IAudioPlayerProps } from 'interfaces/Players/players';
import Logo from 'public/assets/mainLogo.png';

import { Spinner } from '../../Spinner/Spinner';

export default function AudioPlayer({ url, mimetype }: IAudioPlayerProps) {
  const [showAudio, setShowAudio] = useState('hidden');

  const onLoad = () => {
    setShowAudio('');
  };

  return (
    <>
      <div className="w-full h-full p-4 flex flex-col justify-center items-center bg-white relative">
        <div className="w-full h-full p-4 flex flex-col justify-center rounded-md items-center bg-yellow relative">
          <img src={Logo.src} className="w-[400px] max-h-full" alt="" />
          {showAudio === 'hidden' && <Spinner />}
          <audio
            controls
            className={`${showAudio} w-[98%]  absolute bottom-2`}
            onLoadedData={onLoad}
          >
            <source src={url} type={mimetype} />
            Your browser does not support the audio element.
          </audio>
        </div>
      </div>
    </>
  );
}
